import {Component, Input, OnInit} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap";

@Component({
  selector: 'app-video-player-modal',
  templateUrl: './video-player-modal.component.html',
  styleUrls: ['./video-player-modal.component.scss']
})
export class VideoPlayerModalComponent implements OnInit {
  @Input() videoList;
  @Input() trayImageAttachment;

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit() {
  }

}
